import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { ContentContainer, PageWrapper } from './component.styles'

import SubLandingBanner from 'experienceComponents/SubLandingBanner'
import ContentCallout from 'experienceComponents/ContentCallout'

import NavigationHelper from 'layers/navigation/navigationHelper'

class ResourcesSubLandingPageV3 extends Component {
  static propTypes = {
    articles: PropTypes.arrayOf(PropTypes.object),
    banner: PropTypes.object,
    navigationEvent: PropTypes.func,
    pageType: PropTypes.string,
    productTabTitle: PropTypes.string,
  }

  componentDidMount() {
    this.syncDocumentTitle()
  }

  componentDidUpdate() {
    this.syncDocumentTitle()
  }

  syncDocumentTitle() {
    const { banner, productTabTitle } = this.props
    const { title } = banner || {}
    const fullTitle = `${productTabTitle} | ${title}`

    if (title && productTabTitle && document.title !== fullTitle) {
      document.title = fullTitle
    }
  }

  render() {
    const { articles = [], banner, pageType } = this.props || {}

    const filteredArticles = articles.filter(
      article => article.body && article.title,
    )

    const navigateToDashboardOnClick = () => {
      const { navigationEvent } = this.props
      navigationEvent('/dashboard', NavigationHelper.types.PUSH)
    }

    return (
      <PageWrapper>
        <SubLandingBanner
          key="banner"
          navigateToDashboardOnClick={navigateToDashboardOnClick}
          pageType={pageType}
          shouldShowSiteSelector={false}
          {...banner}
        />
        <ContentContainer>
          {filteredArticles.map((article, index) => {
            const uniqueId = `article-${index + 1}`
            return (
              <ContentCallout
                {...article}
                dataTestId={uniqueId}
                key={uniqueId}
              />
            )
          })}
        </ContentContainer>
      </PageWrapper>
    )
  }
}

export default ResourcesSubLandingPageV3
